<template>
  <div class="cc-acc-content">
    <div class="cc-acc-content-drawer">
      <div class="acc-content-drawer-left">
        <el-form label-position="left" label-width="50px">
          <div class="cc-advertiser-form-box">
            <div class="form-box-top">
              <el-form-item label="类型">
                <el-select v-model="filterForm.registerType" size="small">
                  <el-option label="不限" value>不限</el-option>
                  <el-option label="企业" :value="0"></el-option>
                  <el-option label="个人" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="form-box-top">
              <el-form-item label="公司/个人名称" label-width="110px">
                <el-input v-model="filterForm.partnerName" size="small" @keyup.enter.native="handleRefresh" clearable></el-input>
              </el-form-item>
            </div>
            <div class="form-box-top">
              <el-form-item label="状态">
                <el-select v-model="filterForm.partnerStatus" size="small">
                  <el-option label="不限" value>不限</el-option>
                  <el-option label="禁用" :value="0"></el-option>
                  <el-option label="启用" :value="1"></el-option>
                  <el-option label="待审核" :value="2"></el-option>
                  <el-option label="审核不通过" :value="3"></el-option>
                  <el-option label="草稿" :value="4"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="acc-content-drawer-right">
        <el-button size="small" type="primary" icon="el-icon-search" @click.stop="handleRefresh">查询</el-button>
        <el-button size="small" @click.stop="resetFilter">重置</el-button>
        <el-button size="small" type="text" v-if="isMore" class="is-more" @click="clickLoadingMore">
          {{isMore ? '收起' : '展开'}}
          <i :class="isMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </el-button>
      </div>
    </div>
    <div class="cc-acc-content-list">
      <div class="cc-acc-head-but">
        <el-button size="small" type="primary" class="btn-fl" @click="handleCreate">+ 创建广告主</el-button>
      </div>
      <Table :props="table.props" :header="table.header" :data="table.data" v-loading="loading" />
      <pagination
        v-bind:currentpage="currentPage"
        v-bind:pagesize="pageSize"
        v-bind:totalcount="totalCount"
        @handle-size-change="handleSizeChange"
        @handle-current-change="handleCurrentChange"
      ></pagination>
    </div>
    <el-dialog title="广告主审核状态" :visible.sync="showStatus">
      <template slot="title">
        <div class="dialog-title">广告主审核状态</div>
      </template>
      <Table :props="statusTable.props" :header="statusTable.header" :data="statusTable.data" />
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      filterForm: {
        registerType: '',
        legalPerson: '',
        partnerStatus: ''
      },
      table: {
        props: {
          border: true,
          stripe: false,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: 'ID',
            prop: 'partnerId',
            'show-overflow-tooltip': true,
            align: 'left',
            'min-width': 40
          },
          {
            label: '法人',
            prop: 'legalPerson',
            'show-overflow-tooltip': true,
            align: 'left',
            'min-width': 100
          },
          {
            label: '公司/个人名称',
            prop: 'partnerName',
            'show-overflow-tooltip': true,
            align: 'left',
            'min-width': 100
          },
          {
            label: '行业',
            prop: 'registerType',
            'show-overflow-tooltip': true,
            align: 'left',
            'min-width': 100,
            render: (createElement, { row }) => {
              const arr = ['公司', '个人']
              return arr[row.registerType]
            }
          },
          {
            label: '状态',
            prop: 'partnerStatus',
            'show-overflow-tooltip': true,
            align: 'left',
            'min-width': 80,
            render: (createElement, { row }) => {
              const arr = ['禁用', '启用', '待审核', '审核不通过', '草稿']
              return arr[row.partnerStatus]
            }
          },
          // {
          //   'render-header': row => {
          //     return (
          //       <div>
          //         <span>审核状态</span>
          //         <el-tooltip content="审核通过/媒体方" effect="light" placement="right">
          //           <i class="el-icon-question grid-tooltip-icon"></i>
          //         </el-tooltip>
          //       </div>
          //     )
          //   },
          //   prop: 'approveStatus',
          //   align: 'center',
          //   'min-width': 120,
          //   isShow: true,
          //   render: (h, { row }) => {
          //     if (!row.partnerCableList || row.partnerCableList.length === 0) {
          //       return '-'
          //     }
          //     const success = row.partnerCableList.filter(item => item.checkStatus === 1)
          //     return (
          //       <div>
          //         {success.length}/{row.partnerCableList.length}
          //         <i
          //           class="el-icon-view"
          //           style="margin-left:10px;color:#FF8B00;cursor:pointer;"
          //           title="查看审核状态"
          //           onClick={() => this.handleShowStatus(row)}
          //         ></i>
          //       </div>
          //     )
          //   }
          // },
          {
            label: '操作拦',
            align: 'left',
            'min-width': 100,
            // fixed: 'right',
            isShow: true,
            render: (h, { row }) => {
              const disabled = row.partnerStatus === 0 || row.partnerStatus === 1
              return h('div', [
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: event => {
                        event.stopPropagation()
                        this.handleRead(row)
                      }
                    }
                  },
                  '详情'
                ),
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text',
                      disabled
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: event => {
                        event.stopPropagation()
                        this.handleEdit(row)
                      }
                    }
                  },
                  '编辑'
                )
              ])
            }
          }
        ],
        data: [],
        selected: [],
        selectionType: 'multiple'
      },
      pageSize: 10,
      currentPage: 1,
      totalCount: 1,
      selected: [],
      selectedRow: [],
      isMore: false,
      showStatus: false,
      statusTable: {
        props: {
          border: true,
          'tooltip-effect': 'dark',
          'cell-style': { padding: '0' },
          'max-height': 400
        },
        header: [
          {
            label: '媒体方',
            align: 'left',
            prop: 'cableName',
            width: 100,
            'show-overflow-tooltip': true
          },
          {
            label: '推送状态',
            align: 'left',
            prop: 'pushStatus',
            'min-width': 100,
            formatter: row => {
              if (row.pushStatus === 0) {
                return '未推送'
              } else if (row.pushStatus === 1) {
                return '已推送'
              } else if (row.pushStatus === 2) {
                return '推送失败'
              } else {
                return '-'
              }
            }
          },
          {
            label: '审核状态',
            align: 'left',
            prop: 'checkStatus',
            'min-width': 150,
            formatter: row => {
              if (row.checkStatus === 0) {
                return '待审核'
              } else if (row.checkStatus === 1) {
                return '已审核'
              } else if (row.checkStatus === 2) {
                return '审核不通过'
              } else {
                return '-'
              }
            }
          },
          {
            label: '不通过原因',
            align: 'left',
            prop: 'checkRemark',
            'min-width': 150,
            'show-overflow-tooltip': true
          },
          {
            label: '操作',
            align: 'left',
            width: 100,
            render: (h, { row }) => {
              return h(
                'el-button',
                {
                  props: { type: 'text' },
                  on: {
                    click: event => {
                      event.stopPropagation()
                      this.handleApprove(row)
                    }
                  }
                },
                '提交审核'
              )
            }
          }
        ],
        data: []
      }
    }
  },
  methods: {
    fetchData() {
      let filterForm = this.filterForm
      filterForm.pageNo = this.currentPage
      filterForm.pageSize = this.pageSize
      this.table.data = []
      this.drawerDialog = false
      this.loading = true
      this.$service
        .getAccAdDspPartnerPageList(filterForm)
        .then(data => {
          this.totalCount = data.total || 0
          this.table.data = data.rows || []
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleCreate() {
      this.$emit('create')
    },
    resetFilter() {
      this.filterForm = {
        registerType: '',
        legalPerson: '',
        partnerStatus: ''
      }
      this.handleRefresh()
    },
    clickLoadingMore() {
      this.isMore = !this.isMore
    },
    handleFilter() {
      this.drawerDialog = true
    },
    handleRead(row) {
      this.$emit('read', row)
    },
    handleEdit(row) {
      this.$emit('edit', row)
    },
    // 表格操作
    handleRefresh() {
      this.currentPage = 1
      this.fetchData()
    },
    // 每页显示数据量变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange: function (val) {
      this.pageSize = val
      this.fetchData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.fetchData()
    },
    handleClose() {
      this.drawerDialog = false
    },
    handleShowStatus(row) {
      this.statusTable.data = this.cloneDeep(row.partnerCableList)
      this.showStatus = true
    },
    handleApprove(row) {
      const param = {
        partnerCableId: row.partnerCableId
      }
      this.$service.partnerCableApprove(param).then(res => {
        if (res.code === 0) {
          this.fetchData()
          this.$message.success('提交审核成功')
        }
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>
<style lang="stylus" scoped>
.el-drawer__wrapper .el-drawer__header span:focus
  outline 0px
.el-drawer__wrapper .el-drawer.ttb
  height auto !important
.cc-acc-content
  padding 16px
.cc-acc-content .cc-acc-head-but
  overflow hidden
.cc-acc-content .cc-acc-head-but .el-button.btn-fl
  margin-bottom 16px
.cc-acc-content .cc-acc-head-but .btn-fl
  float left
.cc-acc-content .cc-acc-head-but .btn-fr
  float right
.cc-acc-content-list
  background #FFF
  padding 16px 24px
.cc-acc-content-drawer
  background #FFF
  background rgba(255, 255, 255, 1)
  border-radius 2px
  padding 16px 16px 16px 24px
  margin-bottom 16px
  display flex
  flex-direction row
.cc-advertiser-form-box
  display flex
.form-box-top
  width 30%
.form-box-top>div
  margin-right 16px
>>>.el-select
  display flex
>>>.el-table-button-text
  color #1890FF
>>>.el-table-button-text.is-disabled
  color #C0C4CC
.acc-content-drawer-left
  width calc(100% - 147px)
.acc-content-drawer-left .cc-advertiser-form-box .el-form-item
  margin-bottom 0
.cc-acc-content-drawer .is-more
  // color: #FF8B00;
  font-size 14px
  // cursor: pointer;
.acc-content-drawer-right
  width 139px
  margin-right 8px
.grid-tooltip-icon
  margin 3px 0 0 10px
  color #333
  font-size 16px
.dialog-title
  border-bottom 1px solid #eee
  padding-bottom 10px
</style>
